import { render } from "./DropdownComposition.vue?vue&type=template&id=86e555f8"
import script from "./DropdownComposition.vue?vue&type=script&lang=ts"
export * from "./DropdownComposition.vue?vue&type=script&lang=ts"
script.render = render

export default script